<div class="container benefitsContainer" id="benefits">
  <div class="row">
    <div class="col-xs-12 contentContainer benefits border-top">
      <div class="row">
        <div class="col-12">
          <h2>{{contentBenefits?.heading}}</h2>
          <p>{{contentBenefits?.text}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-3 contentContainer"
          *ngFor="let benefit of contentBenefits?.benefitsOrder1; let i = index">
          <img src={{imagePrefix}}{{benefit.imgURL}} alt="" role="presentation" aria-hidden="true">
          <h3 [innerHTML]="benefit.heading"></h3>
          <p [innerHTML]="benefit.text"></p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-3 contentContainer"
          *ngFor="let benefit of contentBenefits?.benefitsOrder2; let i = index">
          <img src={{imagePrefix}}{{benefit.imgURL}} alt="" role="presentation" aria-hidden="true">
          <h3 [innerHTML]="benefit.heading"></h3>
          <p [innerHTML]="benefit.text"></p>
        </div>
      </div>
      <div class="row bordertop">
        <div class="col-xs-12">
          @if(contentBenefits?.additionInformation.text){
            <p class="disclaimer2">
              <a href={{contentBenefits?.additionInformation.url}} target="_blank" rel="noopener" id="terms-costco"
                tabindex="0" title="{{contentBenefits?.additionInformation.text}}"
                (click)="initTaggingTransformationRewards()">
                <span aria-hidden="true"> <sup>1</sup>{{contentBenefits?.additionInformation.text}}</span>
              </a>
            </p>
          }
          @if(contentBenefits?.additionInformation.disclaimer){
          <p class="disclaimer">
            {{contentBenefits?.additionInformation.disclaimer}}<br>
          </p>
          }
          @if(contentBenefits?.additionInformation.protectionBenefits){
          <p class="disclaimer">
            {{contentBenefits?.additionInformation.protectionBenefits}}
            <br>
          </p>
          }
          @if(contentBenefits?.additionInformation.consumerBenefit.text){
          <div class="disclaimer2"><a class="tagging_download_consumer"
              href={{contentBenefits?.additionInformation.consumerBenefit.url}}
              (click)="initTaggingTransformationConsumer()">{{contentBenefits?.additionInformation.consumerBenefit.text}}</a>
          </div>
          }
          @if(contentBenefits?.additionInformation.businessBenefit.text){
          <div class="disclaimer2"><a class="tagging_download_business"
              href={{contentBenefits?.additionInformation.businessBenefit.url}}
              (click)="initTaggingTransformationBusiness()">{{contentBenefits?.additionInformation.businessBenefit.text}}</a>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>